import { Amount, AmountSkeleton } from 'components/shared/Amount/Amount';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { useExistsValidationErrorFor } from '../ValidationErrorsContext';

interface OwnProps {
  dailyNumberOfShares?: number;
  visible: boolean;
  onChange: (newDailyNumberOfShares: number | undefined) => void;
}
export const DailyNumberOfShares: FC<OwnProps> = ({ dailyNumberOfShares, visible, onChange }) => {
  const intl = useIntl();
  const hasError = useExistsValidationErrorFor('dailyNumberOfShares');
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);

  if (!visible) {
    return null;
  }
  return (
    <BlockOrientationFormGroup inputId="dailyNumberOfShares" label="addon.dailyNumberOfShares">
      {!isLoading && (
        <Amount
          isDisabled={isReadOnly}
          e2e="addon-investment-details-dailyNumberOfShares"
          id="addonDailyNumberOfShares"
          placeholder={intl.formatMessage({ id: 'addon.dailyNumberOfShares' })}
          value={dailyNumberOfShares}
          onChange={onChange}
          hasError={hasError}
        />
      )}
      {isLoading && <AmountSkeleton />}
    </BlockOrientationFormGroup>
  );
};

DailyNumberOfShares.displayName = 'DailyNumberOfShares';
